export const MESSAGE = {
  SUCCESS: 'Success',
  SUCCESS_MESSAGE: 'Thao tác thành công',
  SERVER_ERROR: 'Lỗi hệ thống',
  WARNING_MESSAGE: 'Cảnh báo',
  SERVER_ERROR_MESSAGE: 'Không thể tải được dữ liệu',
  CAN_NOT_CREATE_DATA_MESSAGE: 'Không tạo được dữ liệu mới',
  CAN_NOT_REMOVE_OWNER: 'Ít nhất 1 chủ sở hữu tài sản',
}



// WEBPACK FOOTER //
// ./src/common/message.js